import React from 'react';

import {
    endOfMonth,
    endOfQuarter,
    endOfYear,
    startOfMonth,
    startOfQuarter,
    startOfYear,
} from 'date-fns';
import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {DateRange} from 'components/ui-kit/DateRange';

export const AuditPeriodFilter = ({
    value,
    onChange,
}: {
    value?: [Date | null, Date | null];
    onChange?: (value: [Date | null, Date | null] | undefined) => void;
}) => {
    const {t} = useTranslation();
    const periods = [
        {key: 'month', start: startOfMonth, end: endOfMonth},
        {key: 'quarter', start: startOfQuarter, end: endOfQuarter},
        {key: 'year', start: startOfYear, end: endOfYear},
    ];
    return (
        <div>
            <div style={{display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap'}}>
                {periods.map(({key, start, end}) => (
                    <Button
                        key={key}
                        size="sm"
                        variant={ButtonVariant.Secondary}
                        onClick={() => {
                            const now = new Date();
                            onChange?.([
                                start(now),
                                new Date(Math.min(end(now).getTime(), now.getTime())),
                            ]);
                        }}
                    >
                        {t(`pages.productCardAudit.periods.${key}`)}
                    </Button>
                ))}
            </div>
            <DateRange value={value} onChange={onChange} />
        </div>
    );
};
